import { Route, Routes } from '@angular/router';
import authRoutes from './features/auth/routes';
import { LayoutComponent } from './core/layout/layout.component';
import branchRoutes from './features/branch/routes';
import claimRouters from './features/claim/routes';
import craneRoutes from './features/crane/routes';
import policiesRoutes from './features/policy/routes';
import workshopRoutes from './features/workshop/routes';
import { MsalGuard } from '@azure/msal-angular';
import dashboardRoutes from './features/dashboard/routes';
import claimRequestRoutes from './features/claim-request/routes';
import { CanActivateGuard } from './core/guards/auth.guard';
import { ClaimRequestCreateComponent } from './features/claim-request/ui/claim-request-create/claim-request-create.component';
import { ClaimRequestListComponent } from './features/claim-request/ui/claim-request-list/claim-request-list.component';


const claimRequestRoutesIOS: Route[] = [
    {
      path: 'claim-requests',
      canActivate: [CanActivateGuard],
      children: [

        {
          path: 'create',
          component: ClaimRequestCreateComponent
        },
        {
          path: ':idNumber',
          component: ClaimRequestListComponent
        }
      ]
    }
  ]

export const routes: Routes = [
  ...authRoutes,
  ...craneRoutes,
  ...claimRequestRoutesIOS,
  {
    path: '',
    canActivate: [MsalGuard],
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      ...policiesRoutes,
      ...branchRoutes,
      ...claimRouters,
      ...workshopRoutes,
      ...dashboardRoutes,
      ...claimRequestRoutes,
    ],
  },
];
